import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  let list: any[] = []
  if (data.instrumentList.length > 0) {
    data.instrumentList.map((item) => {
      if (item?.instrumentId) {
        list.push({
          id: item?.instrumentId,
          type: item?.instrumentType,
          name: item?.instrumentName ?? item?.instrumentId ?? 'NA',
          logo: item?.imageUrl,
        })
      }
    })
  }
  return list
}

const getPaymentsInstruments = (instrumentType: number, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: `${APIEndPoints.getPaymentInstruments}/${instrumentType}`,
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getPaymentsInstruments }
